export default "__VITE_ASSET__WkhyBCR9__"